import React from "react";
import { TableCell, TableRow, Autocomplete, TextField, Checkbox } from "@mui/material";
import styled from "styled-components";

const ButtonWrapper = styled.div`
  display: flex;
`;

const AMeditablerow = ({
  k, row, editFormData,
  handleCancelClick, tableFontSize = 14,
  nameStringFn, user, SubmitButton,
  page, rowsPerPage, onChangeEditCateg,
  assetmaster, icon, checkedIcon, consumablecat
}) => {
  const responsiveFontSize = tableFontSize;

  return (
    <TableRow key={k} name={row?.Category} sx={{ fontSize: responsiveFontSize }}>
      <TableCell component="th" scope="row" sx={{ padding: '8px' }}>
        {page * rowsPerPage + k + 1}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.storeoffice}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          onChange={(event, newValue) =>
            onChangeEditCateg(event, newValue, `ApplAssetCateg`)
          }
          size="small"
          value={editFormData?.ApplAssetCateg || []}
          options={
            assetmaster
              ? Object.values(assetmaster)
                  ?.map((x) => x.Category)
                  .sort()
              : []
          }
          disableCloseOnSelect
          getOptionLabel={(option) => option}
          renderOption={(props, option, { selected }) => (
            <li {...props} style={{ fontSize: "12px" }}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 0, marginLeft: -8 }}
                checked={selected}
              />
              {option}
            </li>
          )}
          sx={{ width: 200 }}
          renderInput={(params) => <TextField {...params} label="Asset Category" sx={{ background: "white", width: "100%", fontSize: "12px" }} />}
        />
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          size="small"
          value={editFormData?.ApplConsumCateg ?? []} // Use nullish coalescing for safety
          onChange={(event, newValue) => onChangeEditCateg(event, newValue, "ApplConsumCateg")}
          options={
            consumablecat
              ? [...new Set(Object.values(consumablecat).map(x => x?.name))].sort()
              : []
          }        
          disableCloseOnSelect
          getOptionLabel={(option) => option || ""} // Fallback to an empty string
          renderOption={(props, option, { selected }) => (
            <li {...props} style={{ fontSize: '12px' }}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 0, marginLeft: -8 }}
                checked={selected}
              />
              {option}
            </li>
          )}
          sx={{ width: 200 }}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Select Consumable Category" 
              sx={{ background: "white", width: "100%", fontSize: "12px" }} 
            />
          )}
        />
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.ItemAdder_A?.length && user?.[row?.roleUsers?.ItemAdder_A]
          ? nameStringFn(user[row?.roleUsers?.ItemAdder_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Approver_A?.length && user?.[row?.roleUsers?.L1Approver_A]
          ? nameStringFn(user[row?.roleUsers?.L1Approver_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Approver_A?.length && user?.[row?.roleUsers?.L2Approver_A]
          ? nameStringFn(user[row?.roleUsers?.L2Approver_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1ReqApprover_A?.length && user?.[row?.roleUsers?.L1ReqApprover_A]
          ? nameStringFn(user[row?.roleUsers?.L1ReqApprover_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2ReqApprover_A?.length && user?.[row?.roleUsers?.L2ReqApprover_A]
          ? nameStringFn(user[row?.roleUsers?.L2ReqApprover_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.ItemAdder_C?.length && user?.[row?.roleUsers?.ItemAdder_C]
          ? nameStringFn(user[row?.roleUsers?.ItemAdder_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Approver_C?.length && user?.[row?.roleUsers?.L1Approver_C]
          ? nameStringFn(user[row?.roleUsers?.L1Approver_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Approver_C?.length && user?.[row?.roleUsers?.L2Approver_C]
          ? nameStringFn(user[row?.roleUsers?.L2Approver_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1ReqApprover_C?.length && user?.[row?.roleUsers?.L1ReqApprover_C]
          ? nameStringFn(user[row?.roleUsers?.L1ReqApprover_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2ReqApprover_C?.length && user?.[row?.roleUsers?.L2ReqApprover_C]
          ? nameStringFn(user[row?.roleUsers?.L2ReqApprover_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Support?.length && user?.[row?.roleUsers?.L1Support]
          ? nameStringFn(user[row?.roleUsers?.L1Support])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Support?.length && user?.[row?.roleUsers?.L2Support]
          ? nameStringFn(user[row?.roleUsers?.L2Support])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ padding: '8px' }}>
        <ButtonWrapper>
          <SubmitButton sx={{ marginRight: 1, fontSize: '12px', height: 30 }} type="submit">
            Save
          </SubmitButton>
          <SubmitButton sx={{ marginRight: 1, fontSize: '12px', height: 30 }} type="button" onClick={(e) => handleCancelClick(e, k)}>
            Cancel
          </SubmitButton>
        </ButtonWrapper>
      </TableCell>
    </TableRow>
  );
};

export default AMeditablerow;
